import { DatasourceId, NetworkId } from '../types';
import { openMapAddress } from './openMap';

interface MapPageParams {
  datasourceId?: DatasourceId;
  latitude?: number;
  longitude?: number;
  zoom?: number;
  searchedLatitude?: number;
  searchedLongitude?: number;
}

function createQueryString(params: MapPageParams) {
  const qs = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return qs ? `?${qs}` : '';
}

function createMapPageRelativeUrl(networkId: NetworkId, datasourceId: DatasourceId | null, params: MapPageParams) {
  return `${networkId}${datasourceId ? `/ds/${datasourceId}` : ''}${createQueryString(params)}`;
}

export function createShareUrl(networkId: NetworkId, datasourceId: DatasourceId | null, params: MapPageParams) {
  return `${openMapAddress}/api/share/${createMapPageRelativeUrl(networkId, datasourceId, params)}`;
}

export function createMapUrl(networkId: NetworkId, datasourceId: DatasourceId | null, params: MapPageParams) {
  return `${openMapAddress}/${createMapPageRelativeUrl(networkId, datasourceId, params)}`;
}

export function createWidgetCreatorUrl(networkId: NetworkId) {
  return `${openMapAddress}/${networkId}/create-widget`;
}

export function createMapWidgetRelativeUrl(networkId: NetworkId, params: MapPageParams) {
  return `${networkId}/widgets/v1/map${createQueryString(params)}`;
}
